module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-10.cc7114c6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/sortie-10.png
// module id = 2758
// module chunks = 11